module.exports = __webpack_public_path__ + "img/Atención al cliente.47540b58.png";